import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { SimulationRunSummary } from '../../../../types/simulation';

interface Metric {
  label: string;
  field: string;
  icon: React.ReactNode;
  unit: string;
}

interface MetricsGridProps {
  metrics: Metric[];
  selectedSim: SimulationRunSummary;
}

const MetricsGrid: React.FC<MetricsGridProps> = ({ metrics, selectedSim }) => (
  <Box
    display="grid"
    gridTemplateColumns={{ xs: '1fr 1fr', sm: 'repeat(3, 1fr)', md: 'repeat(5, 1fr)', lg: 'repeat(7, 1fr)' }}
    gap={1.5}
    alignItems="stretch"
    justifyContent="center"
    sx={{ width: '100%', maxWidth: '100vw', overflow: 'hidden' }}
  >
    {metrics.map(({ label, field, icon, unit }) => {
      let value = selectedSim[field as keyof SimulationRunSummary];
      if (typeof value === 'number') {
        value = unit === '%' ? (value * 100).toFixed(2) + unit : value.toFixed(2) + unit;
      } else if (value !== undefined && value !== null) {
        value = value + unit;
      } else {
        value = '--';
      }
      return (
        <Paper
          key={field}
          elevation={2}
          sx={{
            p: 1.2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
            borderRadius: 2,
            background: '#ffffff',
            minHeight: 80,
            minWidth: 0,
            boxShadow: '0 2px 8px 0 rgba(0,0,0,0.06)',
            transition: 'box-shadow 0.2s',
            '&:hover': { boxShadow: '0 4px 16px 0 rgba(0,0,0,0.10)' },
          }}
        >
          <Box fontSize={22} color="primary.main">{icon}</Box>
          <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ fontSize: 18, wordBreak: 'break-all', lineHeight: 1 }}>
            {value}
          </Typography>
          <Typography variant="caption" color="textSecondary" fontWeight={500} textAlign="center" sx={{ fontSize: 12, lineHeight: 1.1 }}>
            {label}
          </Typography>
        </Paper>
      );
    })}
  </Box>
);

export default MetricsGrid; 